// extracted by mini-css-extract-plugin
module.exports = {"link":"_2tcsV","image":"_3_NbI","root":"_1F6na"};